import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _jsxFileName = "/Users/brentvatne/coding/react-navigation-stack/src/views/Header/HeaderTitle.tsx";
import * as React from 'react';
import { Platform, StyleSheet, Animated } from 'react-native';

var HeaderTitle = function HeaderTitle(_ref) {
  var style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["style"]);

  return React.createElement(Animated.Text, _extends({
    numberOfLines: 1
  }, rest, {
    style: [styles.title, style],
    accessibilityTraits: "header",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  }));
};

var styles = StyleSheet.create({
  title: _objectSpread({}, Platform.select({
    ios: {
      fontSize: 17,
      fontWeight: '600',
      color: 'rgba(0, 0, 0, .9)',
      marginHorizontal: 16
    },
    android: {
      fontSize: 20,
      fontWeight: '500',
      color: 'rgba(0, 0, 0, .9)',
      marginHorizontal: 16
    },
    default: {
      fontSize: 18,
      fontWeight: '400',
      color: '#3c4043'
    }
  }))
});
export default HeaderTitle;